var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dealers-container"},[_c('DetailImages',{attrs:{"images":_vm.imagesData,"rows":2,"page-size":100}}),_c('DetailVideo',{attrs:{"videos":_vm.videoPageData,"rows":1,"page-size":100}}),_c('div',{staticStyle:{"height":"80px"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }